import React from 'react'
import styled from 'styled-components'
import Youtube from './Images/email-icon.png'
import Email from './Images/email-icon.png'
import Instagram from './Images/instagram icon.png'
import Whatsapp from './Images/phone-icon.png'

function About() {
  return (
    <AboutContain>
      <Container>
        <h1>ABOUT THE LEAGUE</h1>
        <p>UNILAG (Community) Basketball League, UBL, is a basketball League
          that aims at giving a platform for STEAM students and workers to 
          play the game they love in an organied setting.
        </p>
        <p>STEAM stands for Science, Technology, Engineering, Arts, Mathematics.</p>
        <p>The League is organized by Coach Okolo Emmanuel, head coach of UNILAG
           basketball team, and Stemballer.</p>
        <p>The main character in the logo is Dr. Ayo, a basketball veteran and retired 
          Engineering lecturer at University of first choice.
        </p>

        <Social>
          <a href='https://youtube.com/@stemballer'><img src={Youtube} alt='img'/></a>
          <a href='https://instagram.com/stemballer'><img src={Instagram} alt='img'/></a>
          <a href='https://wa.me/+2348183641142'><img src={Whatsapp} alt='img'/></a>
          <a href='ma'><img src={Email} alt='img'/></a>
        </Social>
      </Container>
    </AboutContain>
  )
}

export default About



const AboutContain = styled.div`
width: 100%;
display: flex;
justify-content: center;
background-color: maroon;
color: goldenrod;
`

const Container = styled.div`
width: 80%;
display: flex;
flex-direction: column;
align-items: center;
`

const Social = styled.div`
width: 100%;
display: flex;
justify-content: space-around;
align-items: center;
padding-top: 10px;
`